import React from 'react';
import './Sections.scss';

function Section6() {
  return (
    <section className="sections sections-section6">
      <h2 className="sections-title">Stability – and tax advantages – of home ownership</h2>
      <p className="sections-copy">
        Cryptocurrencies and meme stocks may get all the hype, but their values are subject to wild
        fluctuations. While flashy investments might offer higher percentage gains in a certain
        month or quarter, home values tend to have much less fluctuation over time. That kind of
        steady price appreciation is what builds long-term wealth – and helps buyers sleep soundly.
      </p>
      <p className="sections-copy">
        And there’s another financial benefit that homeowners enjoy. Investors who sell assets such
        as stocks or bonds that have appreciated in price typically are responsible for paying taxes
        on the difference between the purchase price and the sales price – what’s known as the
        capital gain. By contrast, with some exceptions, sellers can exclude up to $250,000 of net
        profit from the sale of their main home (or up to $500,000 in gains for sellers who file
        joint tax returns) provided that they have owned and used the home as their primary
        residence for at least two out of the five years preceding the sale.<sup>1</sup>
      </p>
    </section>
  );
}

export default Section6;
